import React from 'react';
import PropTypes from 'prop-types';

import { DateIntervalPoint } from './DateIntervalPoint';

export const DateIntervalSet = ({ startConfig, endConfig }) => {
    return (
        <>
            <DateIntervalPoint config={startConfig} />
            <DateIntervalPoint config={endConfig} />
        </>
    );
};

DateIntervalSet.propTypes = {
    startConfig: PropTypes.shape({ ...DateIntervalPoint.propTypes }).isRequired,
    endConfig: PropTypes.shape({ ...DateIntervalPoint.propTypes }).isRequired,
};

export default DateIntervalSet;
